/**
 * 指定したID内のリンクにパラメータを自動付与する関数
 * from_brand=cast_colon&type=cast_colon
 * @param {string} targetId - 監視対象のID
 * @param {Object} params - 追加したいパラメータ { key: value }
 */
const getCurrentVisumoProductGroupId = () => {
  if (!window.location.pathname.startsWith('/products/')) return '';

  const hiddenGroupInput = document.getElementById('hidden_variation_group');
  const hiddenGroupValue = hiddenGroupInput?.value?.toString().trim();
  if (hiddenGroupValue) return hiddenGroupValue.toUpperCase();

  const pathSegments = window.location.pathname.match(/([^/.]+)/g) || [];
  const productPathSegment = pathSegments[pathSegments.length - 1] || '';
  return decodeURIComponent(productPathSegment).trim().toUpperCase();
};

const isVisumoCoordinateListPath = (pathname) => (
  pathname === '/pages/coordinate'
  || pathname.startsWith('/pages/coordinate-')
  || pathname === '/coordinate'
  || pathname.startsWith('/coordinate-')
);

const observeAndAddParams = (targetId, brandCode) => {
  const targetNode = document.getElementById(targetId);
  if (!targetNode) return;

  const updateLink = (link, force = false) => {
    if ((!force && link.dataset.paramApplied) || !link.href || link.href.startsWith('javascript:')) {
      return;
    }

    try {
      /***
       * URLの書き換え
       * URLが以下の場合にそれぞれ末尾に「-{brandCode}」に変更を加える
       * /pages/coordinate, /pages/coordinate-detail, /pages/staff, /pages/staff-detail
       * /coordinate, /coordinate-detail, /staff, /staff-detail
       */
      const url = new URL(link.href);

      // URLパスの書き換え（-detailを先にチェックして部分一致を防ぐ）
      if (brandCode) {
        const pathRewriteMap = [
          { from: '/pages/coordinate-detail', to: `/pages/coordinate-detail-${brandCode}` },
          { from: '/pages/coordinate', to: `/pages/coordinate-${brandCode}` },
          { from: '/pages/staff-detail', to: `/pages/staff-detail-${brandCode}` },
          { from: '/pages/staff', to: `/pages/staff-${brandCode}` },
          { from: '/coordinate-detail', to: `/coordinate-detail-${brandCode}` },
          { from: '/coordinate', to: `/coordinate-${brandCode}` },
          { from: '/staff-detail', to: `/staff-detail-${brandCode}` },
          { from: '/staff', to: `/staff-${brandCode}` },
        ];
        for (const { from, to } of pathRewriteMap) {
          if (url.pathname === from || url.pathname.startsWith(from + '/')) {
            url.pathname = url.pathname.replace(from, to);
            break;
          }
        }
      }

      // 商品詳細のVisumo一覧からコーディネート一覧へ遷移する場合は商品番号検索を付与
      const isVisumoProductSection = Boolean(
        link.closest('.hacobune-goods')
        || targetNode.querySelector('.hacobune-goods')
      );
      if (
        isVisumoProductSection
        && isVisumoCoordinateListPath(url.pathname)
        && window.location.pathname.startsWith('/products/')
      ) {
        const productGroupId = getCurrentVisumoProductGroupId();
        if (productGroupId) {
          url.searchParams.set('vsm_item_group_id', productGroupId);
        }
      }

      link.href = url.toString();
      // 重複処理防止フラグ
      link.dataset.paramApplied = 'true';
    } catch (e) {
      console.error('Invalid URL:', link.href);
    }
  };

  const updateLinks = (container) => {
    // container内（またはcontainer自身）のリンクを抽出
    const links = container instanceof HTMLAnchorElement
      ? [container]
      : Array.from(container.querySelectorAll?.('a') || []);

    links.forEach(link => {
      updateLink(link);
    });
  };

  const handleLinkClick = (event) => {
    const clickedLink = event?.target?.closest?.('a');
    if (!clickedLink || !targetNode.contains(clickedLink)) return;

    updateLink(clickedLink, true);
  };

  // 1. 初期読み込み時の実行
  updateLinks(targetNode);
  targetNode.addEventListener('click', handleLinkClick, true);

  // 2. MutationObserverの設定
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // 新しく要素が追加された場合
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // ELEMENT_NODE
            updateLinks(node);
          }
        });
      }
    });
  });

  // 監視開始
  observer.observe(targetNode, {
    childList: true, // 子要素の変化を監視
    subtree: true    // 孫要素以下もすべて監視
  });
}
